import { IChangedValue } from 'interfaces/merge/IChangedValue';
import moment from 'moment';
import { ISession } from 'interfaces/session/ISession';
import { IApiTeam } from 'interfaces/team/IApiTeam';
import { findTeamInSession, serializeValue } from './mergeHelpers';
import { emptyGuid } from '../../constants/Constants';

export class ValueMerger {
  public isChanged = false;

  public changedValues: IChangedValue[] = [];

  public merge = <T>(csvValue: T, playValue: T, propName: string) => {
    const csvValueString = serializeValue(csvValue);
    const playValueString = serializeValue(playValue);
    if (csvValueString !== playValueString) {
      this.isChanged = true;
      this.changedValues.push({ csvValue: csvValueString, playValue: playValueString, propName });
    }
    return csvValue;
  };

  public mergeDates = (csvDate: string, playDate: string | undefined, propName: string) => {
    if (!csvDate || !moment(csvDate).isValid()) {
      return playDate;
    }
    if (!playDate || Math.abs(moment(csvDate).diff(playDate, 'milliseconds')) > 100) {
      this.isChanged = true;
      this.changedValues.push({ csvValue: csvDate, playValue: playDate || '', propName });
    }
    return csvDate;
  };

  public mergeTeam = (csvTeamShortName: string, playTeam: IApiTeam, session: ISession, propName: string) => {
    if (csvTeamShortName === playTeam.shortName) {
      return playTeam;
    }
    this.isChanged = true;
    this.changedValues.push({ csvValue: csvTeamShortName, playValue: playTeam.shortName, propName });
    const sessionTeam = findTeamInSession(csvTeamShortName, session);
    return sessionTeam || { id: emptyGuid, name: '', shortName: csvTeamShortName, externalId: '' };
  };
}
